import { React, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import Navbar from "./Components/Navbar";
import FoodItems from "./Components/FoodItems";
import BrandItems from "./Components/brandItems";
import AllCollection from "./Components/AllCollection";
import Menu from "./Components/Menu";
import Restaurent from "./Components/Restaurent";
import Footer from "./Components/Footer";
import SavedCollection from "./Components/SavedCollection";
import "./App.css";
import "./Components/Responsive.css";

import "typeface-roboto";
import FilterHighPrice from "./Components/FilterHighPrice";
import LowPrice from "./Components/LowPrice";
import HighPrice from "./Components/HighPrice";
import FoodDetails from "./Components/FoodDetails";


function App() {
  const [search, setSearch] = useState('');
  const searchHandler = (event) => {
    setSearch(event.target.value);
  }
  const searchHandlerOnClick = (event) => {
    setSearch(event.target.value);
  }

  return (
    <>
      <BrowserRouter>
        <Navbar search={search} searchHandler={searchHandlerOnClick} searchHandlerOnChange={searchHandler} />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <FoodItems />
                <BrandItems />
                <Menu search={search} />
              </>
            }
          />
          <Route path="/collection-saved" Component={SavedCollection} />
          <Route path="/restaurent" Component={Restaurent} />
          <Route path="/collections" Component={AllCollection} />
          <Route path="/FilterRating4+" Component={FilterHighPrice} />
          <Route path="/LowPrice" Component={LowPrice} />
          <Route path="/HighPrice" Component={HighPrice} />
          <Route path="/Fooddetails" Component={FoodDetails} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
